export default "__VITE_ASSET__effe152a__"